import {shareState} from "../../../app/share-state";
import {GameWidgetInputModel} from "../../games-widget/models/games.widget.game-input-model";

export class HomeWidgetGameModel extends GameWidgetInputModel {
  get bottomStatus() {
    if(this.isLive || this.isEnded) {
      return shareState.termsUtils.terms.WC_2022_POINTS;
    }

    return `${this.formatDate(this.startTime)} - ${this.formatTime(this.startTime)}`;
  }
}
